// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {}

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.admin') ? [] : [
    {
        path: 'user-actions',
        name: consts.routerNames.users.actions,
        meta: {
            mainRouteName: consts.routerNames.users.actions,
            bodyGrid: "1X1",
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/intuit/admin/UserActionsPage.vue')
    },
];

export default routes